import {
  Button,
  Card,
  Col,
  ConfigProvider,
  Layout,
  message,
  Pagination,
  Row,
  Timeline,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import PageHeader from '../common/page-header/header'
import zhCN from 'antd/lib/locale/zh_CN'

import css from './index.module.less'
import PageFooter from '../common/page-footer/footer'
import { sendHttpPostRequest } from '@/api/http-request'
import SearchInput from '../components/SearchInput/SearchInput'
import * as constants from '../../constants/constants'
import { useHistory, useLocation } from 'react-router-dom'

function LoginRecords() {
  const query = useRef('')
  const page = useRef(1)
  const pageSize = useRef(20)
  const [total, setTotal] = useState(0)

  const [recordList, setRecordList] = useState([] as any)
  const location: any = useLocation()
  const history = useHistory()
  const prePath: any = location?.state?.pre_path

  const onPageChange = (np, nps) => {
    page.current = np
    setRecordList([])
    getCollegeLoginRecords()
  }

  useEffect(() => {
    getCollegeLoginRecords()
    return () => {}
  }, [])

  const getCollegeLoginRecords = () => {
    let data = {
      page: page.current,
      query: query.current,
    }
    sendHttpPostRequest('college/api/get_college_login_log', data, (res) => {
      if (res.code == 0) {
        setRecordList([...res.data.list])
        setTotal(res.data.page_info.total_count)
      } else {
        message.error(res.msg)
      }
    })
  }

  return (
    <Layout style={{ minHeight: 750, backgroundColor: '#f9f9f9' }}>
      <PageHeader keys={[]} />

      <Card
        extra={
          <Button
            type="link"
            onClick={() => {
              history.push(prePath)
            }}
          >
            {'返回 >'}
          </Button>
        }
        title={<span className={css.cardTitle}>动态</span>}
        className={css.cardContain}
      >
        <div className={css.timeContain}>
          <div style={{ width: '400px' }}>
            <Timeline mode="left">
              {recordList?.map((item) => (
                <Timeline.Item
                  dot={<div className={css.timeDot}></div>}
                  key={item.id}
                  label={item.log_time}
                >
                  <Row align="middle">
                    <Col>
                      <img
                        style={{ marginRight: '5px' }}
                        className={css.avatar}
                        src={constants.BACKEND_API_URL + item.avatar}
                        alt="头像加载失败"
                      />
                    </Col>
                    <Col style={{ marginRight: '10px' }}>
                      {item.real_name || item.user_name}
                    </Col>
                    <Col>{item.log_type}</Col>
                  </Row>
                </Timeline.Item>
              ))}
            </Timeline>
          </div>

          <div className={css.searchInpt}>
            <SearchInput
              onSearch={() => {
                page.current = 1
                setRecordList([])
                getCollegeLoginRecords()
              }}
              width={220}
              placeholder="请输入姓名"
              onChange={(e) => {
                query.current = e.target.value
              }}
            />
          </div>
        </div>

        <ConfigProvider locale={zhCN}>
          <div className={css.pagination}>
            <Pagination
              current={page.current}
              total={total}
              pageSize={pageSize.current}
              hideOnSinglePage={true}
              onChange={onPageChange}
            />
          </div>
        </ConfigProvider>
      </Card>

      <PageFooter />
    </Layout>
  )
}

export default LoginRecords
